// 活动类型 - 普通活动
const ORDINARY_ACTIVITY_TYPE = 0
// 活动类型 - 特殊活动
const SPECIAL_ACTIVITY_TYPE = 1
// 以旧换新活动
const TRADE_IN_ACTIVITY = 1
// 一站式换新
const ONE_STOP_ACTIVITY = 6
// 镭雕
const LASER_CARVING_ACTIVITY = 2
// 免邮活动
const FREE_SHIPPING_ACTIVITY = 3
// 贺卡
const GREETING_CARD_ACTIVITY = 7
// 移动合约机 8
export default {
  ORDINARY_ACTIVITY_TYPE,
  SPECIAL_ACTIVITY_TYPE,
  TRADE_IN_ACTIVITY,
  LASER_CARVING_ACTIVITY,
  FREE_SHIPPING_ACTIVITY,
  ONE_STOP_ACTIVITY,
  GREETING_CARD_ACTIVITY
}
